import React from 'react'
import { FetchUserPlaylistsPlaylistTypeEnum as playlistTypeEnum } from '@swagger'
import PlaylistGrid from '@components/Playlist/PlaylistGrid'

interface PlaylistTabBCProps {
  playlistType: playlistTypeEnum
}

const PlaylistTabBC: React.FC<PlaylistTabBCProps> = ({ playlistType }) => {
  return <PlaylistGrid playlistType={playlistType} basePath="business" />
}

export default PlaylistTabBC
